import React from 'react';
import Hero from '../components/Hero.js';
import About from '../components/About.js';
import CTASection from '../components/CTASection.js';
import SEO from '../components/SEO.js';
import { ShieldCheck, Award, Users, HardHat } from 'lucide-react';

const homeSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://vijayindustry.co.in/#organization",
      "name": "Vijay Industry",
      "url": "https://vijayindustry.co.in",
      "logo": "https://vijayindustry.co.in/logo.png",
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+91-9444833272",
        "contactType": "customer service",
        "areaServed": "IN",
        "availableLanguage": ["English", "Tamil"]
      }
    },
    {
      "@type": "LocalBusiness",
      "@id": "https://vijayindustry.co.in/#localbusiness",
      "name": "Vijay Industry",
      "image": "https://vijayindustry.co.in/logo.png",
      "url": "https://vijayindustry.co.in",
      "telephone": "+91-9444833272",
      "email": "vijayindustry.info@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Coimbatore",
        "addressRegion": "Tamil Nadu",
        "addressCountry": "IN"
      },
      "priceRange": "₹₹",
      "description": "Manufacturer & fabricator of Pre-Engineered Buildings, factory sheds, warehouses, mezzanine floors, and structural steel solutions in Coimbatore."
    }
  ]
};

export default function Home() {
  return (
    <div className="page-home animate-fade-in">
      <SEO 
        title="Vijay Industry | Pre-Engineered Buildings & Industrial Steel Structures"
        description="Vijay Industry offers complete industrial & structural solutions in Coimbatore, including PEB structures, factory sheds, warehouses, roofing sheets, MS fabrication, and SS railings."
        keywords="Pre-Engineered Buildings Coimbatore, PEB Structure Manufacturers Tamil Nadu, Factory Shed Contractors, Industrial Steel Warehouse Construction, Mezzanine Floor Fabricators, Roofing Sheet Installation Coimbatore"
        canonical="/"
        schemaData={homeSchema}
      />
      {/* 1. Hero Showcase Section */}
      <Hero />
      
      {/* 2. Brand Identity / About Section */}
      <About />
      
      {/* 3. trust statistics / Company achievements metrics */}
      <section className="section" style={{ backgroundColor: 'var(--background)', borderBottom: '1px solid var(--border)' }}>
        <div className="container">
          <div className="home-stats-grid" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '2rem',
            textAlign: 'center'
          }}>
            {/* Stat Item 1 */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
              <div style={{ color: 'var(--accent)', backgroundColor: '#FFF3E6', padding: '0.75rem', borderRadius: '50%', display: 'flex' }}>
                <HardHat size={24} />
              </div>
              <h2 style={{ fontSize: '2.5rem', fontWeight: 800, color: 'var(--primary)', margin: 0 }}>500+</h2>
              <p style={{ fontWeight: 600, fontSize: '0.9rem', color: 'var(--muted)' }}>Projects Completed</p>
            </div>
            
            {/* Stat Item 2 */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
              <div style={{ color: 'var(--accent)', backgroundColor: '#FFF3E6', padding: '0.75rem', borderRadius: '50%', display: 'flex' }}>
                <Award size={24} />
              </div>
              <h2 style={{ fontSize: '2.5rem', fontWeight: 800, color: 'var(--primary)', margin: 0 }}>15+</h2>
              <p style={{ fontWeight: 600, fontSize: '0.9rem', color: 'var(--muted)' }}>Years Experience</p>
            </div>
            
            {/* Stat Item 3 */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
              <div style={{ color: 'var(--accent)', backgroundColor: '#FFF3E6', padding: '0.75rem', borderRadius: '50%', display: 'flex' }}>
                <ShieldCheck size={24} />
              </div>
              <h2 style={{ fontSize: '2.5rem', fontWeight: 800, color: 'var(--primary)', margin: 0 }}>100%</h2>
              <p style={{ fontWeight: 600, fontSize: '0.9rem', color: 'var(--muted)' }}>Quality Assured</p>
            </div>
            
            {/* Stat Item 4 */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
              <div style={{ color: 'var(--accent)', backgroundColor: '#FFF3E6', padding: '0.75rem', borderRadius: '50%', display: 'flex' }}>
                <Users size={24} />
              </div>
              <h2 style={{ fontSize: '2.5rem', fontWeight: 800, color: 'var(--primary)', margin: 0 }}>250+</h2>
              <p style={{ fontWeight: 600, fontSize: '0.9rem', color: 'var(--muted)' }}>Happy Clients</p>
            </div>
          </div>
        </div>
      </section>
      
      {/* 4. Conversion CTA Banner */}
      <CTASection />
    </div>
  );
}
